import { AnimationController, Animation } from '@ionic/angular/standalone';
export const enterAnimation = (baseEl: HTMLElement, opts?: any): Animation => {
  const duration = 500;

  const animationCtrl = new AnimationController();

  if (opts.direction === 'forward') {
    // forwards animation
    const rootAnimation = animationCtrl
      .create()
      .addElement(opts.enteringEl)
      .duration(duration)
      .easing('ease-in')
      .fromTo('transform', 'translateX(50px)', 'translateX(0px)')
      .fromTo('opacity', 0, 1);

    const leavingAnimation = animationCtrl
      .create()
      .addElement(opts.leavingEl)
      .duration(duration)
      .easing('ease-in')
      .fromTo('transform', 'translateY(0px)', 'translateY(50px)')
      .fromTo('opacity', 1, 0);

    return animationCtrl
      .create()
      .addAnimation([rootAnimation, leavingAnimation]);
  } else {
    // backwards animation
    const rootAnimation = animationCtrl
      .create()
      .addElement(opts.enteringEl)
      .duration(duration)
      .easing('ease-in')
      .fromTo('transform', 'translateY(50px)', 'translateY(0px)')
      .fromTo('opacity', 0, 1);

    const leavingAnimation = animationCtrl
      .create()
      .addElement(opts.leavingEl)
      .duration(duration)
      .easing('ease-in')
      .fromTo('transform', 'translateX(0px)', 'translateX(50px)')
      .fromTo('opacity', 1, 0);

    return animationCtrl
      .create()
      .addAnimation([rootAnimation, leavingAnimation]);
  }
};
